import { render } from "./ProductRating.vue?vue&type=template&id=9b454d38&scoped=true"
import script from "./ProductRating.vue?vue&type=script&lang=js"
export * from "./ProductRating.vue?vue&type=script&lang=js"

import "./ProductRating.vue?vue&type=style&index=0&id=9b454d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b454d38"]])

export default __exports__